const LAST_APP_VIEW_KEY = "lastAppView";

interface AppViews {
  "custom-lists"?: string;
  widgets?: string;
  events?: string;
  directory?: string;
  storefront?: string;
  adminland?: string;
  orgHome?: string;
  home?: string;
  homeManageSection?: string;
  homeReviewSection?: string;
}

const getSelectedAppViews = (): AppViews => {
  const sessionItem = sessionStorage.getItem(LAST_APP_VIEW_KEY) ?? "{}";
  return JSON.parse(sessionItem) as AppViews;
};

export const getSelectedAppView = (appKey: keyof AppViews) => {
  const appViews = getSelectedAppViews();
  return appViews[appKey] ?? "";
};

export const setSelectedAppView = (appKey: keyof AppViews, viewKey: string) => {
  const appViews = getSelectedAppViews();
  appViews[appKey] = viewKey;
  sessionStorage.setItem(LAST_APP_VIEW_KEY, JSON.stringify(appViews));
};
